import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {ButtonMain, CheckboxMain, CreateCancelButtons, DateCalendarForm} from "components";
import {Svg} from "assets";
import {FindError, FindLoad, FindSuccess, newDateWithoutUtc, Notify, usePrimaryModal} from "utils";
import {ModesEnum, weeks} from "../constants";
import {httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, legsActions} from "store";


const ACTION_TYPE = 'REPEAT_WEEKLY'

export const RepeatWeekly = ({tripId, isCreated, anotherData, afterSuccess}) => {
    const [currentWeeks, setCurrentWeeks] = useState([]);
    const [errorWeeks, setErrorsWeek] = useState(false);
    const {control, handleSubmit, watch} = useForm({});
    const dispatch = useDispatch()
    const {closePrimary} = usePrimaryModal();
    const success = FindSuccess(ACTION_TYPE);
    const beckError = FindError(ACTION_TYPE);
    const loading = FindLoad(ACTION_TYPE)


    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            Notify('Trips successfully created for the selected period.', 'success');
            closePrimary();
            if (afterSuccess) {
                afterSuccess()
            }
        }
    }, [success]);

    useEffect(() => {
        if (beckError?.error) {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
            Notify('Something went wrong.', 'error')
        }
    }, [beckError]);

    const changeWeeks = (e) => {
        const value = +e.target.value;
        const checked = e.target.checked;

        const newWeeks = checked
            ? [...currentWeeks, value]
            : currentWeeks.filter(week => week !== value);

        setCurrentWeeks(newWeeks)
        setErrorsWeek(false)
    }

    const onSubmit = (data) => {
        const params = {
            tripId,
            pattern: {
                startDate: newDateWithoutUtc(data.startDate),
                endDate: newDateWithoutUtc(data.endDate),
                mode: ModesEnum.WEEKLY,
                repeatCheckWeek: currentWeeks,
            }
        }

        if (isCreated) {
            params.tripData = anotherData
        }

        if (currentWeeks.length) {
            dispatch(legsActions.repeatWeekly(params))
        } else {
            setErrorsWeek(true)
        }
    }

    return (
        <form
            className='repeat-weekly-wrapper'
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="modal-header-main">
                <h2 className="modal-header-title">Repeat weekly</h2>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={closePrimary}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <div className='flex-gap-16'>
                    <DateCalendarForm
                        control={control}
                        name='startDate'
                        label='From'
                        max={watch("endDate")}
                        rules={{
                            required: true
                        }}
                    />

                    <DateCalendarForm
                        control={control}
                        name='endDate'
                        label='To'
                        min={watch("startDate")}
                        rules={{
                            required: true
                        }}
                    />
                </div>

                <div className='repeat-weekly-weeks-wrapper' style={errorWeeks ? {border: '1px solid #E63946'} : {}}>
                    {weeks.map((week, index) => (
                        <div className='repeat-weekly-week-box' key={index}>
                            <CheckboxMain
                                label={week.name}
                                onChange={changeWeeks}
                                value={index}
                            />
                        </div>
                    ))}
                </div>

            </div>
            <CreateCancelButtons
                createText={"Save"}
                loading={!!loading?.length}
                onCancel={closePrimary}
                createBtnStyles={{
                    width: "86px",
                }}
            />
        </form>
    );
};

